/**
 * @generated SignedSource<<5259db3c4de28f2a0290357a56d75375>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreatePlaceholderAllocationInput = {
  startDate?: string | null;
  endDate?: string | null;
  placeholderId?: string | null;
  projectId?: string | null;
  projectGroupId?: string | null;
  monday?: number | null;
  tuesday?: number | null;
  wednesday?: number | null;
  thursday?: number | null;
  friday?: number | null;
  saturday?: number | null;
  sunday?: number | null;
  description?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createPlaceholderAllocationMutation$variables = {
  input: CreatePlaceholderAllocationInput;
};
export type createPlaceholderAllocationMutation$data = {
  readonly createPlaceholderAllocation: {
    readonly placeholderAllocation: {
      readonly id: string;
      readonly startDate: string | null;
      readonly endDate: string | null;
      readonly monday: number | null;
      readonly tuesday: number | null;
      readonly wednesday: number | null;
      readonly thursday: number | null;
      readonly friday: number | null;
      readonly saturday: number | null;
      readonly sunday: number | null;
      readonly description: string | null;
      readonly placeholder: {
        readonly id: string;
      } | null;
    } | null;
  } | null;
};
export type createPlaceholderAllocationMutation = {
  variables: createPlaceholderAllocationMutation$variables;
  response: createPlaceholderAllocationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreatePlaceholderAllocationPayload",
    "kind": "LinkedField",
    "name": "createPlaceholderAllocation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PlaceholderAllocation",
        "kind": "LinkedField",
        "name": "placeholderAllocation",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "monday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tuesday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wednesday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thursday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "friday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "saturday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sunday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Placeholder",
            "kind": "LinkedField",
            "name": "placeholder",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createPlaceholderAllocationMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createPlaceholderAllocationMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0bf498222f1a7d712952f75fd3c6899e",
    "id": null,
    "metadata": {},
    "name": "createPlaceholderAllocationMutation",
    "operationKind": "mutation",
    "text": "mutation createPlaceholderAllocationMutation(\n  $input: CreatePlaceholderAllocationInput!\n) {\n  createPlaceholderAllocation(input: $input) {\n    placeholderAllocation {\n      id\n      startDate\n      endDate\n      monday\n      tuesday\n      wednesday\n      thursday\n      friday\n      saturday\n      sunday\n      description\n      placeholder {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ef35a88d45f5308b5c5dc13dd71f4200";

export default node;
